import {
    isEmailAddressValid, isPostalCodeValid,
    isPhoneValid, isNumeric, containsAlphaNumAndSpaceOnly, containsAlphabetsOnly,
    validAddress, isValidUUID, isDateGreaterThanToday, isValidDate
} from "../../util/Validators";

import { evenRound } from "util/NumberUtils";

export const validateInput = (name, value) => {
    let hasError = false,
        error = ""
    switch (name) {
        case "firstName":
            if (value.trim() === "") {
                hasError = true
                error = "First name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "First name can have only alpha characters."
            } else {
                hasError = false
                error = ""
            }
            break
        case "lastName":
            if (value.trim() === "") {
                hasError = true
                error = "Last name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "Last name can have only alpha characters."
            } else {
                hasError = false
                error = ""
            }
            break
        case "address":
            if (value.trim() === "") {
                hasError = true
                error = "Address name cannot be empty"
            } else if (!validAddress(value)) {
                hasError = true
                error = "Invalid Address."
            } else {
                hasError = false
                error = ""
            }
            break
        case "city":
            if (value.trim() === "") {
                hasError = true
                error = "City name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "City can have only alpha-numeric characters."
            } else {
                hasError = false
                error = ""
            }
            break
        case "state":
            if (value.trim() === "") {
                hasError = true
                error = "State name cannot be empty"
            } else if (!containsAlphaNumAndSpaceOnly(value)) {
                hasError = true
                error = "State can have only alpha-numeric characters."
            } else {
                hasError = false
                error = ""
            }
            break
        case "country":
            if (value.trim() === "") {
                hasError = true
                error = "Country name cannot be empty"
            } else if (!containsAlphabetsOnly(value)) {
                hasError = true
                error = "Invalid Country."
            } else {
                hasError = false
                error = ""
            }
            break
        case "donorEmailAddress":
            if (value.trim() === "") {
                hasError = true
                error = "Email cannot be empty"
            } else if (!isEmailAddressValid(value)) {
                hasError = true
                error = "Invalid Email"
            } else {
                hasError = false
                error = ""
            }
            break
        case "mobilePhoneNumber":
            if (value.trim() === "") {
                hasError = true
                error = "Mobile cannot be empty"
            } else if (!isPhoneValid(value)) {
                hasError = true
                error = "Invalid Mobile Number. Use 10 digits only"
            } else {
                hasError = false
                error = ""
            }
            break
        case "zip":
            if (value.trim() === "") {
                hasError = true
                error = "Postal Code cannot be empty"
            } else if (!isPostalCodeValid(value)) {
                hasError = true
                error = "Invalid Postal Code"
            } else {
                hasError = false
                error = ""
            }
            break
        case "donationLineItems":
            if (!isNumeric(value)) {
                hasError = true
                error = "Payment Amount must be numeric"
            } else {
                hasError = false
                error = ""
            }
            break
        case "terms":
            if (!value) {
                hasError = true
                error = "You must accept terms and conditions"
            } else {
                hasError = false
                error = ""
            }
            break
        case "currentDonationCause":
            if (!value) {
                hasError = true;
                error = "Donation Cause is required. Please select one."
            } else if (!isValidUUID(value)) {
                hasError = true;
                error = "Donation cause is invalid."

            } else {
                hasError = false
                error = ""
            }
            break
        case "currentDonationCauseValue":
            if (!value) {
                hasError = true;
                error = "Donation Amount is required."
            } else if (!isNumeric(value)) {
                hasError = true;
                error = "Donation Amount is invalid."

            } else if (evenRound(parseFloat(value),2) <= parseFloat(0)) {
                hasError = true;
                error = "Donation Amount must be greater than 0.00"
            } else {
                hasError = false
                error = ""
            }
            break
        case "endDate":
            if (!value || value.trim() === "") {
                hasError = false
                error = ""
            } else if (!isValidDate(value)) {
                hasError = true
                error = "End Date is invalid"
            } else if (!isDateGreaterThanToday(value)) {
                hasError = true
                error = "End Date must be greater than today's date"
            } else {
                hasError = false
                error = ""
            }
            break;
        default:
            break
    }
    return { hasError, error }
}